module.exports = __webpack_public_path__ + "static/media/mobile.b75a957b.svg";